type Value =
  | string
  | number
  | { [key: string]: any }
  | Function
  | Array<any>
  | boolean
  | null
  | undefined;

const isEmpty = (value: Value, allowZero: boolean = false) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (Array.isArray(value) || typeof value == "string") {
    return value.length === 0;
  } else if (typeof value == "object") {
    return (
      (Object.keys(value).length === 0 && value.constructor === Object) ||
      Object.values(value).some((v) => !v)
    );
  } else if (typeof value == "number") {
    if (allowZero && value === 0) {
      return false;
    }
    return value === 0;
  } else if (!value) {
    return true;
  }
  return false;
};

export default isEmpty;
